import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ThreeJsLoader } from '../configurator/product/interfaces/ThreejsLoader';
import { BackendService } from './services/backend.service';
import { ThreeJsLoaderService } from './services/three-js-loader.service';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { LoaderComponent } from './loader/loader.component';
import { LoadingService } from './services/loading.service';
import { SnackbarComponent } from './snackbar/snackbar.component';

@NgModule({
  declarations: [LoaderComponent, SnackbarComponent, ConfirmationDialogComponent],
  exports: [LoaderComponent, SnackbarComponent],
  providers: [LoadingService, BackendService, { provide: ThreeJsLoader, useClass: ThreeJsLoaderService }],
  imports: [CommonModule, HttpClientModule, TranslateModule, MatIconModule, FormsModule, SharedModule],
})
export class CoreModule {
  //Constructor makes sure that this is only provided once
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
